import { documentsAreaMessages } from '../../../messages';
import { Column } from '../../column';
import { OfferingDocument } from '../offering-document';

export const offeringDocumentsColumns: Column<OfferingDocument>[] = [
  {
    headerLabel: documentsAreaMessages.titleLabelTable,
    key: 'title',
    type: 'react-node',
  },
  {
    headerLabel: documentsAreaMessages.companyLabelTable,
    key: 'company',
    type: 'string',
  },
  {
    headerLabel: documentsAreaMessages.documentTypeLabelTable,
    key: 'type',
    type: 'string',
  },
  {
    headerLabel: null,
    key: 'flagIsRead',
    type: 'react-node',
  },
];
